export default {"src":"/_next/static/media/stream-chat.3e6aba4d.svg","height":64,"width":253,"blurWidth":0,"blurHeight":0};